import ProductImport from 'components/admin/Products/ProductImport'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loadPathLeaves, loadProductCategories } from 'redux/categories'
import { loadProductState } from 'redux/importer'
import { loadKeywords } from 'redux/keywords'
import { cancelConfirm } from 'redux/navigation'
import { disableForm, initializeImportForm, loadProducts } from 'redux/product'
import { loadProperties } from 'redux/properties'
import { loadUsers } from 'redux/userAdmin'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      initializeImportForm,
      disableForm,
      loadUsers,
      loadProperties,
      loadBreadcrumbs: loadPathLeaves,
      loadProducts,
      loadProductCategories,
      loadKeywords,
      loadProductState,
    },
    dispatch
  )
}

class ProductImportContainer extends React.Component {
  componentWillMount() {
    const {
      match: { params: params = {} },
    } = this.props // react router
    const { initializeImportForm, disableForm } = this.props
    if (params.article_number) initializeImportForm(params.article_number)
    else disableForm()

    const {
      loadProducts,
      loadBreadcrumbs,
      loadProductCategories,
      loadKeywords,
      loadProperties,
      loadUsers,
      loadProductState,
    } = this.props
    loadProducts()
    loadBreadcrumbs()
    loadProductCategories()
    loadKeywords()
    loadProperties()
    loadUsers()
    loadProductState()
  }

  componentWillReceiveProps(nextProps) {
    const {
      match: { params: oldParams = {} },
      initializeImportForm,
    } = this.props
    const {
      match: { params: newParams = {} },
    } = nextProps
    if (oldParams.article_number !== newParams.article_number) {
      initializeImportForm(newParams.article_number)
    }
  }

  render() {
    return <ProductImport />
  }
}

ProductImportContainer = connect(mapStateToProps, mapDispatchToProps)(
  ProductImportContainer
)
export default ProductImportContainer



// WEBPACK FOOTER //
// ./src/containers/admin/product_import.jsx